// Norwegian (Norway)
// nb_NO.js

export default {
  // Vanlige ord (Common words)
  enter: "Gå inn",
  next: "Neste",
  previous: "Forrige",
  finish: "Fullfør",
  returnToWebsite: "Tilbake til nettstedet",
  complete: "Fullført",
  submit: "Send inn",
  cancel: "Avbryt",
  yes: "Ja",
  no: "Nei",
  skip: "Hopp over",
  close: "Lukk",
  discard: "Forkast",
  save: "Lagre",
  "thank-you": "Takk",
  select: "Velg",
  hi: "Hei",
  hello: "Hallo",
  link: "Lenke",
  back: "Tilbake",
  view: "Vis",
  continue: "Fortsett",
  of: "av",

  // Hovedundersøkelse for kunder (Client Survey Main)
  "client-survey-main-thanks-note":
    "Takk for at du tar deg tid, tilbakemeldingen din former vårt tilbud <br /> for fremtiden.",
  "client-survey-how-likely-recommend":
    "Hvor sannsynlig er det at du vil anbefale oss til andre?",
  "client-survey-how-likely-note":
    "På en skala fra 0 - 10, hvor 0 er ikke sannsynlig i det hele tatt og 10 er svært sannsynlig.",
  "client-survey-how-likely-recommend-question":
    "Hva er én ting vi kunne gjort for at du skulle bli mer villig til å anbefale oss?",
  "step-of": "Steg {step} av {total}",
  step: "Steg {step}",
  "client-survey-how-satisfied-with-service":
    "Hvor fornøyd er du med tjenesten",
  "client-survey-how-satisfied-with-service-question":
    "Hva er én ting vi kunne gjort for å forbedre oss?",
  "client-survey-how-satisfied-with-food":
    "Hvor fornøyd er du med maten du får fra oss?",
  "client-survey-how-satisfied-with-food-question":
    "Hva er én ting vi kunne gjort for å forbedre oss?",
  "client-survey-what-is-the-best-thing-about-working-with-us":
    "Hva er det beste med å samarbeide med oss? Velg alt som er relevant.",
  "management-team": "Ledelsesteam",
  "the-front-line-operations-team": "Førstelinjes driftsteam",
  "food-offering": "Mattilbud",
  innovation: "Innovasjon",
  communication: "Kommunikasjon",
  "flexibility-and-responsiveness": "Fleksibilitet og responstid",
  billing: "Fakturering",
  "health-and-hygiene-standards": "Helse- og hygienestandard",
  "if-other-please-specify": "Hvis annet, vennligst spesifiser...",
  "based-on-the-service-we-provide-where-can-we-improve-the-most-please-select-all-that-matters":
    "Basert på tjenesten vi leverer, hvor kan vi forbedre oss mest? Velg alt som er relevant.",
  "please-can-we-have-some-more-detail": "Kan du gi oss flere detaljer?",
  "to-help-us-understand-your-csr-priorities-please-order-in-rank-of-importance-the-following":
    "For å hjelpe oss å forstå dine CSR-prioriteringer, vennligst ranger følgende etter viktighet:",
  "sustainable-ingredients": "Bærekraftige ingredienser",
  "food-waste": "Matsvinn",
  "local-sourcing": "Lokale leverandører",
  "people-and-communities": "Mennesker &amp; lokalsamfunn",
  "energy-reduction": "Energireduksjon",
  "working-with-local-communities": "Samarbeid med lokalsamfunn",
  "environmental-choices": "Miljøvennlige valg",
  "meat-free": "Kjøttfritt",
  "less-plastic": "Mindre plast",
  "would-you-like-to-be-contacted-about-your-feedback":
    "Ønsker du å bli kontaktet angående tilbakemeldingen din? Hvis ja, vennligst legg igjen kontaktinformasjonen din nedenfor",
  "full-name": "Fullt navn",
  "email-address": "E-postadresse",
  "phone-number": "Telefonnummer",
  feedback: "Tilbakemelding",
  "view-our-privacy-policy": "Se vår personvernerklæring",
  "thank-you-for-taking-time-to-complete-the-survey":
    "Takk for at du tok deg tid til å fullføre undersøkelsen!",

  // 404 Ikke funnet (Not found)
  "404-not-found": "404 Ikke funnet",

  // Personvernerklæring (Privacy policy)
  "privacy-policy": "Personvernerklæring",

  // Ansatt nettbasert vurdering tilbakemelding Steg 1 (Employee web rating feedback step 1)
  "employee-web-rating-feedback-step-1-positive":
    "Hyggelig å høre at du er positiv, vi vil gjerne vite hvorfor?",
  "employee-web-rating-feedback-step-1-negative":
    "Beklager å høre at du ikke har det så bra, kan du fortelle oss hvorfor?",

  // Ansatt nettbasert vurdering tilbakemelding Steg 2 (Employee web rating feedback step 2)
  "employee-web-rating-feedback-step-2-heading":
    "Er det noe annet du ønsker å dele med oss i dag?",
  "employee-web-rating-feedback-step-2-information":
    "Har du noen kommentarer eller tilbakemeldinger om din opplevelse hos oss i dag?",
  "employee-web-rating-feedback-step-2-placeholder":
    "Del din opplevelse med oss i dag...",

  // Ansatt nettbasert vurdering tilbakemelding Steg 3 (Employee web rating feedback step 3)
  "employee-web-rating-feedback-step-3-heading":
    "Ønsker du å gi honnør til noen?",
  "no-employees-found": "Ingen ansatte funnet",

  // Ansatt nettbasert vurdering Hjem (Employee web rating home)
  "choose-location": "Velg sted",
  "search-location": "Søk etter sted",
  "feedback-anonymous": "Ønsker du å holde tilbakemeldingen anonym?",
  "feedback-feeling-today": "Hvordan har du det i dag?",

  // Ansatt nettbasert vurdering Takkeside (Employee web rating thank you page)
  "thank-you-for-your-feedback": "Takk for din tilbakemelding!",
  "back-to-home": "Tilbake til forsiden",
  page: "Side",

  // Tilbakemelding én gang varsel (Feedback once alert)
  "feedback-once-alert": "Tilbakemelding er allerede gitt fra denne URL-en.",

  // Front kundeundersøkelse (Front customer survey)
  "please-answer-above-question": "Vennligst svar på spørsmålet over.",
  "add-comments": "Legg til kommentarer",
  "enter-answer": "Skriv svar",
  "add-upload-files": "Legg til filer",

  // Alphega spørsmål (Alphega questions)
  "did-you-buy-medicine-in-the-pharmacy-today":
    "Kjøpte du medisiner på apoteket i dag?",
  "were-you-asked-any-of-the-following": "Ble du spurt om noe av følgende:",
  "who-is-the-medicine-for": "Hvem er medisinen til?",
  "what-are-your-symptoms": "Hva er symptomene dine?",
  "how-long-you-had-the-symptoms": "Hvor lenge har du hatt symptomene?",
  "what-action-you-have-already-taken": "Hvilke tiltak har du allerede prøvd?",
  "are-you-taking-any-other-medication": "Bruker du andre medisiner?",

  // Alphega - Other Companies Questions
  "did-you-wait-more-than-10-minutes-to-be-served":
    "Var det mer enn 10 minutter før du ble servet?",
  "were-the-products-you-wanted-in-stock": "Var produktene du ønsket i lager?",
  "were-the-staff-friendly-and-helpful": "Var personalet vennlig og hjelpsomt?",
  "did-you-receive-any-advice-about-your-medicines":
    "Har du fått noen råd om medisiner?",

  // Front mobil hjem (Front mobile home)
  "how-was-your-experience-with-us-today":
    "Hvordan var din opplevelse hos oss i dag?",

  // Front mobil takkeside (Front mobile thank you page)
  "thank-you-for-your-time-and-your-answers":
    "Takk for tiden din og dine svar.",
  "would-also-like-to-rate-us-on-google": "Vil du også vurdere oss på Google?",
  "rate-us-now": "Vurder oss nå",

  // Negativ chat svar (Negative chat response)
  "select-skill": "Velg ferdighet",
  "none-selected": "Ingen valgt",
  "can-we-get-in-touch-with-you-about-your-experience-today":
    "Kan vi kontakte deg angående din opplevelse i dag?",
  "write-here": "Skriv her...",
  "please-can-we-get-your-name": "Kan vi få navnet ditt?",
  "please-enter-your-email": "Vennligst skriv inn din e-post:",
  "enter-your-phone-number": "Skriv inn ditt telefonnummer:",
  "please-tell-us-a-bit-more-about-your-experience":
    "Fortell oss gjerne litt mer om din opplevelse:",
  "you-have-already-submitted-rating": "Du har allerede sendt inn vurdering",
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Beklager å høre at du ikke hadde den beste opplevelsen hos oss i dag. Kan du fortelle oss hva som gikk galt?",

  // Positiv chat svar (Positive chat response)
  "select-employee": "Velg ansatt",
  "we-d-love-to-know-who-looked-after-you-today":
    "Vi vil gjerne vite hvem som hjalp deg i dag?",
  "what-stood-out-to-you-today": "Hva gjorde spesielt inntrykk på deg i dag?",
  "did-we-provide-exceptional-service-today":
    "Ga vi eksepsjonell service i dag?",
  "do-you-have-any-comments-or-feedback-about-your-experience-with-us-today":
    "Har du noen kommentarer eller tilbakemeldinger om din opplevelse hos oss i dag?",

  // Klient tilkobling leder (Client connect director)
  "message-from-leadership": "Melding fra ledelsen",
  "message-from-leadership-text":
    "Jeg søker kontinuerlig etter måter å forbedre våre tjenester for våre kunder. Er det områder du mener vi kan forbedre?",
  "client-connect-director-another-note":
    "For øvrig, hvis det er et spesifikt tema du ønsker at teamet vårt skal ta opp, ikke nøl med å dele det. Jeg er her ikke bare for å lytte, men for å engasjere meg og handle på dine bekymringer eller ideer.",
  "your-message-here": "Din melding her",
  "visit-information": "Besøksinformasjon",
  "visit-time-out": "Besøkstid utløpt",
  "contact-information": "Kontaktinformasjon",
  "client-connect-director-contact-information-text":
    "For å kunne gi bedre assistanse ber vi om dine detaljer, inkludert navn, e-postadresse og telefonnummer. Denne informasjonen vil gjøre det mulig for oss å svare raskt og kontakte deg.",
  name: "Navn",
  "enter-your-name": "Skriv inn ditt navn",
  email: "E-post",
  "enter-your-email": "Skriv inn din e-post",
  "contact-number": "Telefonnummer",
  "please-enter-your-name": "Vennligst skriv inn ditt navn",
  "please-enter-your-email-or-phone-number":
    "Vennligst skriv inn din e-post eller telefonnummer",
  "invalid-email-address": "Ugyldig e-postadresse",
  "invalid-phone-number-format": "Ugyldig telefonnummer for det valgte landet.",
  "no-match-found": "Ingen treff",
  "phone-number-must-be-digits-for-country":
    "Telefonnummeret må være {count} siffer for det valgte landet ({current}/{count}).",
  "phone-number-must-be-digits-range-for-country":
    "Telefonnummeret må være {min}–{max} siffer for det valgte landet ({current}/{max}).",
  "please-select-time": "Vennligst velg tidspunkt",
  "you-must-provide-at-least-one-answer-before-submitting-the-survey":
    "Du må gi minst ett svar før du sender inn undersøkelsen.",

  // Mobilundersøkelse Spørsmål Avkrysningstype (Mobile survey question checkbox type)
  comment: "Kommentar",
  "comment-is-required": "Kommentar er påkrevd!",
  "minimum-selection-is": "Minimum antall valg er {min_options}",
  "maximum-selection-is": "Maksimum antall valg er {max_options}",
  "this-question-is-required": "Dette spørsmålet er påkrevd!",
  "please-fill-all-required-grid-rows":
    "Vennligst fyll ut alle obligatoriske rutenettlinjer!",
  "please-fill-mandatory-fields-to-continue":
    "Vennligst fyll ut de obligatoriske feltene for å fortsette",

  // Mobilundersøkelse Spørsmål Kommentarer og bilde (Mobile survey question comment and image)
  "please-select-valid-image-files": "Vennligst velg gyldige bildefiler.",

  // Mobilundersøkelse Spørsmål Ansatttype (Mobile survey question employee type)
  loading: "Laster",
  "getting-employee": "Henter ansatt...",

  // Mobilundersøkelse Spørsmål Filopplastingstype (Mobile survey question file upload type)
  "please-select-valid-image-or-video-files":
    "Vennligst velg gyldige bilde- eller videofiler.",
  "please-select-a-valid-file":
    "Vennligst velg en gyldig fil (bilde, video, PDF eller Word).",

  // Mobilundersøkelse Spørsmål Talltype (Mobile survey question number type)
  "please-enter-a-number-without-any-decimal-points":
    "Vennligst skriv inn et helt tall uten desimaler.",
  "please-enter-a-number-less-than-or-equal-to":
    "Vennligst skriv inn et tall mindre enn eller lik {max_number_value}.",

  // Mobilundersøkelse Spørsmål Signaturtype (Mobile survey question signature type)
  "please-complete-your-signature": "Vennligst fullfør signaturen din.",

  // Mobilundersøkelse Spørsmål Teksttype (Mobile survey question text type)
  "please-enter-valid-email-address":
    "Vennligst skriv inn gyldig e-postadresse.",
  "phone-number-should-be-10-digit": "Telefonnummer må være 10 siffer.",
  "please-enter-at-least-characters":
    "Vennligst skriv inn minst {minimum_character} tegn.",
  "select-date": "Velg dato",
  "select-time": "Velg tidspunkt",
  "client-connect-date-picker-aria": "Dato: {value}. Åpne datovelger",
  "client-connect-time-picker-aria": "Tid: {value}. Åpne tidsvelger",
  "select-country": "Velg land",

  // Rapportside (Report page)
  "click-the-link-to-see-how": "Klikk på lenken for å se hvordan.",
  "adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Ved å legge til teamene dine på ServeFirst-rapporteringsplattformen kan de også logge inn for å se sin ytelse, og du har mulighet til å administrere teamet ditt og få tilgang til flere rapporter for å forstå hvordan dere presterer samlet -",
  "did-you-know": "Visste du...",
  count: "antall",
  average: "gjennomsnitt",
  focus: "fokus",
  performance: "Ytelse",
  "you-can-create-bespoke-action-plans":
    "Du kan opprette skreddersydde handlingsplaner som filtreres direkte inn her hvis de opprettes i din ServeFirst-konto. Her kan du opprette handlinger, tidslinjer og eiere umiddelbart mens du sporer ytelsen. -",
  "no-of-times-raised": "Antall ganger nevnt",
  action: "Handling",
  "attribute-name": "Attributtnavn",
  "action-plan": "Handlingsplan",
  "that-by-adding-your-teams-to-the-ServeFirst-reporting-platform":
    "Ved å legge til teamene dine på ServeFirst-rapporteringsplattformen kan de også logge inn for å se sin ytelse, og du har mulighet til å administrere teamet ditt og få tilgang til flere rapporter for å forstå hvordan dere presterer samlet -",
  result: "Resultat",
  category: "Kategori",
  "your-location-vs-all-location": "Din lokasjon vs. alle lokasjoner",
  "net-promoter-score": "Net Promoter Score",
  "responses-breakdown": "Fordeling av svar",
  "trended-net-promoter-score": "Net Promoter Score-trend",
  "trended-results": "Resultattrender",
  "net-promoter-score-info":
    "Net Promoter Score er basert på % av promotører (Score 5/5) - % av kritikere (Score 1, 2 eller 3), du kan finne ut mer om Net Promoter Score ved å klikke på følgende",
  "customer-feedback": "Kundetilbakemelding",
  logan: "Logan",
  "top-performer": "Topputøver",
  "rank-in-the-country": "Rangering i landet",
  "ytd-score": "Hittil i år-score",
  "score-during-period": "Score i perioden",
  "0-from-last-month": "0 fra forrige måned",
  "total-responses-for-july-2021": "Totale svar for juli 2021",
  promoter: "Promotør",
  "from-04-sep-2021-to-06-sep-2021": "Fra 04. sep. 2021 til 06. sep. 2021",
  "the-focus-currently-is-on": "Fokuset er for tiden på",
  "1-number-of-customers-have-stated-this-as-an-opportunity":
    "1 kunde har oppgitt dette som en mulighet.",
  "focus-for-the-month": "Fokus for måneden",
  "download-pdf": "Last ned pdf",

  // Rapportside Ny rapport (Report page new report)
  "total-responses": "Totalt antall svar",
  duration: "Varighet",
  "customers-have-stated-this-as-an-opportunity":
    "kunder har oppgitt dette som en mulighet",
  "error-fetching-params": "Feil ved henting av parametere!",
  "previous-days-was": "Foregående {days} dager var {score}",

  // Rapportside Felles LgCard (Report page common LgCard)
  "raised-on": "# Registrert den",
  results: "Resultater",

  // Rapportside Komponenter AI-forslag (Report page AI suggestions)
  "analyzing-data-please-wait": "Analyserer data, vennligst vent...",

  // Rapportside Komponenter Kundetilbakemelding (Report page customer feedback)
  "view-report": "Vis rapport",
  "received-on": "Mottatt den",

  // Rapportside Komponenter Svarfordeling (Report page answer distribution)
  detractors: "Kritikere",
  nps: "NPS",

  // Rapportside Komponenter Trendresultater (Report page trend results)
  "trend-results": "Trendresultater",

  // Undersøkelse hjelpere Verktøy (Survey helper tools)
  "failed-to-fetch-the-pdf-file": "Kunne ikke hente PDF-filen",
  "error-generating-pdf-thumbnail": "Feil ved generering av PDF-miniatyr",
  "error-in-thumbnail-generation-function":
    "Feil i miniatyrgeneringsfunksjonen",
  "failed-to-generate-pdf-thumbnail": "Kunne ikke generere PDF-miniatyr",

  // Undersøkelse Sider Revisjon (Survey revision)
  "select-audit": "Velg revisjon",

  // Undersøkelse Sider Klienttilkobling
  "select-atleast-min-options": "Velg minst {minOptions} alternativer",
  "select-max-options": "Maksimalt {maxOptions} alternativer tillatt!",
  "error-saving-your-response": "Feil ved lagring av svaret ditt!",
  "failed-to-load-the-file": "Kunne ikke laste inn filen!",
  "open-link": "Åpne lenke",
  download: "Last ned",
  details: "Detaljer",
  title: "Tittel",
  description: "Beskrivelse",
  "general-info": "Generell info",
  type: "Type",
  size: "Størrelse",
  "uploaded-by": "Lastet opp av",

  // Undersøkelse Sider Klienttilkobling Intro (Client connect intro)
  "thank-you-for-your-time": "Takk for tiden din!",

  // Undersøkelse Sider Klienttilkobling Innhold (Client connect content)
  "review-content": "Gjennomgå innhold",

  // Undersøkelse Sider Klienttilkobling Undersøkelse (Client connect survey)
  "please-give-us-your-feedback": "Vennligst gi oss din tilbakemelding",
  "enter-your-response": "Skriv inn ditt svar",

  // Client Connect v2 (accordion UI)
  "client-connect-preview-hey": "Hei, {name}",
  "client-connect-preview-sent-from": "Sendt fra {sender} - {date}",
  "client-connect-preview-step-of": "Trinn {current} av {total}",
  "client-connect-preview-getting-started": "Kom i gang",
  "client-connect-preview-getting-started-desc":
    "Ta en titt på oversiktsressursene som er forberedt for deg.",
  "client-connect-preview-share-feedback": "Del tilbakemeldingen din",
  "client-connect-preview-share-feedback-desc":
    "Din tilbakemelding hjelper oss å bygge en bedre opplevelse for deg.",
  "client-connect-preview-talk-leadership": "Snakk med ledelsen",
  "client-connect-preview-talk-leadership-desc":
    "Les meldingen fra ledelsen og lagre svaret ditt.",
  "client-connect-preview-reviewed-these": "Jeg har gjennomgått disse",
  "client-connect-preview-send-feedback": "Send tilbakemelding",
  "client-connect-preview-finish-submit": "Fullfør og send",
  "client-connect-preview-save-finish": "Fullfør og send",
  "client-connect-preview-your-reply": "Ditt svar",
  "client-connect-preview-saved": "Lagret",
  "client-connect-preview-edit": "Rediger",
  "client-connect-preview-pop-out": "Åpne i vindu",
  "client-connect-preview-open": "Åpne",
  "client-connect-preview-view": "Vis",
  "client-connect-preview-welcome": "Velkommen",
  "client-connect-preview-feedback": "Tilbakemelding",
  "client-connect-preview-save-message": "Send melding",
  "client-connect-preview-message-footer":
    "Meldingen din går direkte til lederteamet.",
  "client-connect-preview-leadership-placeholder": "Skriv inn meldingen din...",
  "client-connect-preview-thank-you": "Takk",
  "client-connect-preview-thank-you-body":
    "Du har fullført Client Connect. Spørreundersøkelsessvarene og meldingen din er sendt til teamet — de tar snart kontakt.",
  "client-connect-thank-you-message":
    "Takk for tiden din. Tilbakemeldingen din betyr virkelig noe.",
  "client-connect-preview-review-answers": "Gjennomgå svarene mine",
  "client-connect-preview-back-dashboard": "Tilbake til dashbordet",
  "client-connect-preview-already-submitted":
    "Tilbakemeldingen din er mottatt. Takk! Du kan gjerne se gjennom materialene ovenfor.",
  "enter-email-address": "Skriv inn e-postadresse",
  "enter-phone-no": "Skriv inn telefonnummer",
  "product-type": "Produkttype",
  "enter-number": "Skriv inn nummer",
  aspect: "Aspekt",

  // Undersøkelse Sider Klienttilkobling Leder (Client connect director)
  "i-am-constantly-seeking-ways-to-better-our-offerings-for-our-clientele":
    "Jeg søker kontinuerlig etter måter å forbedre våre tjenester for våre kunder. Er det områder du mener vi kan forbedre?",
  "on-another-note-if-there-s-a-specific-topic-you-d-like-our-team-to-address-don-t-hesitate-to-share":
    "For øvrig, hvis det er et spesifikt tema du ønsker at teamet vårt skal ta opp, ikke nøl med å dele det. Jeg er her ikke bare for å lytte, men for å engasjere meg og handle på dine bekymringer eller ideer.",
  "to-provide-enhanced-assistance-we-kindly-ask-for-your-details-including-your-name-email-address-and-contact-number":
    "For å kunne gi bedre assistanse ber vi om dine opplysninger, inkludert navn, e-postadresse og telefonnummer. Denne informasjonen vil gjøre det mulig for oss å svare raskt og kontakte deg.",

  // Undersøkelse Sider Lokasjon (Location)
  "select-the-location-you-visited": "Velg lokasjonen du besøkte",
  locations: "Lokasjoner",
  "is-this-your-current-location": "Er dette din nåværende lokasjon?",
  "nearest-location": "Nærmeste lokasjon",
  "loading-data": "Laster data...",
  "please-wait": "Vennligst vent!",

  // Undersøkelse Sider Lokasjonsområde (Location area)
  "location-area": "Lokasjonsområde",
  "select-location-area": "Velg lokasjonsområde",

  // Undersøkelse Sider Innlogging (Login)
  "please-enter-your-password": "Vennligst skriv inn ditt passord",
  "value-must-be-longer-than-3-characters": "Verdien må være lengre enn 3 tegn",
  "please-enter-your-email-address": "Vennligst skriv inn din e-postadresse",
  password: "Passord",
  "internal-server-error": "Intern serverfeil!",
  "sign-in": "Logg inn",

  // Undersøkelse Sider SammeDagsUndersøkelse (Same day survey)
  "you-have-already-performed-this-survey":
    "Du har allerede gjennomført denne undersøkelsen!",
  "csat-link-invalid": "Denne lenken til undersøkelsen er ikke lenger gyldig.",

  // Undersøkelse Sider UndersøkelseTakkForHjelpen (Survey thank you for help)
  "your-feedback-has-been-submitted":
    "Din tilbakemelding er sendt inn. Ditt saksnummer er #",
  "a-member-of-the-team-will-be-in-touch-shortly":
    "Et medlem av teamet vil ta kontakt snart.",
  "would-you-also-like-to-rate-us-on-google":
    "Ønsker du også å vurdere oss på Google?",
  "to-review-our-terms-and-conditions-please-click":
    "For å se våre vilkår og betingelser, vennligst klikk",
  here: "Her",
  "ticket-number-copied-to-clipboard": "Saksnummer kopiert til utklippstavlen",

  // Undersøkelse Sider Velkommen (Welcome)
  "visit-date": "Besøksdato",
  "visit-time-in": "Innsjekkingstidspunkt",
  "please-select-date": "Vennligst velg dato",
  "guest-info": "Gjesteinformasjon",
  "please-select-user": "Vennligst velg bruker",
  "get-started": "Kom i gang",

  // Undersøkelse Sider Beholdningstype (Inventory type)
  "enter-value": "Skriv inn verdi",
  "getting-product-list": "Henter produktliste...",

  // Undersøkelse Sider NotatOgBilde (Note and image)
  "upload-file": "Last opp fil",

  // Undersøkelse Sider Talltype (Number type)
  "enter-digit": "Skriv inn tall",

  // Undersøkelse Sider Tekstområde (Text area)
  "enter-your-comment": "Skriv din kommentar",

  // Undersøkelse Sider Opplasting (Upload)
  "file-size-should-be-less-than-10-mb":
    "Filstørrelsen må være mindre enn 10 MB",
  "drag-you-files-here-file-size-less-than-10-mb-or":
    "Dra filene dine hit, filstørrelse mindre enn 10 MB eller",
  "upload-or-drag-and-drop-your-files-here":
    "Last opp eller dra og slipp filene dine her",
  "browse-files": "Bla gjennom filer",

  // Undersøkelse Sider Spørsmål (Questions)
  "next-question": "Neste spørsmål",
  "save-and-exit": "Lagre og avslutt",
  "failed-to-save-and-exit":
    "Kunne ikke lagre fremgangen din. Vennligst prøv igjen.",
  "progress-saved-you-may-close-this-tab":
    "Fremgangen din er lagret. Du kan nå lukke denne nettleserfanen.",
  "please-enter-at-least": "Vennligst skriv inn minst {min} tegn.",
  "contact-no": "Telefonnr",
  "please-select-location": "Vennligst velg lokasjon!",
  "please-select-survey": "Vennligst velg undersøkelse!",
  "please-enter-your-email-address-or-phone-number":
    "Vennligst skriv inn din e-postadresse eller telefonnummer.",

  // Verktøy KomprimerFiler (Compression error)
  "compression-error": "Komprimeringsfeil:",

  // Nettbasert Vurdering FrontInnlogging (Front login)
  "enter-location-id": "Skriv inn lokasjons-ID",
  "invalid-location-id": "Ugyldig lokasjons-ID",
  "location-id-required": "Lokasjons-ID er påkrevd",

  // Nettbasert Vurdering Indeks (Index)
  "please-tell-us-how-your-experience-was-today":
    "Fortell oss gjerne hvordan din opplevelse var i dag.",

  // Nettbasert Vurdering Negativtilbakemelding (Negative feedback)
  "sorry-to-hear-you-didn-t-have-the-best-experience-today-with-us-please-could-you-highlight-what-went-wrong":
    "Beklager å høre at du ikke hadde den beste opplevelsen hos oss i dag. Kan du fortelle oss hva som gikk galt?",
  "enter-valid-email-address": "Skriv inn gyldig e-postadresse.",
  "can-we-get-in-touch-with-you": "Kan vi ta kontakt med deg?",

  // Nettbasert Vurdering Positivtilbakemelding (Positive feedback)
  "enter-your-telephone-number": "Skriv inn ditt telefonnummer",
  "write-your-feedback": "Skriv din tilbakemelding",

  // Nettbasert Vurdering Positivtilbakemelding2 (Positive feedback 2)
  "what-made-the-employee-name-stand-out-to-you":
    "Hva gjorde at {employeeName} skilte seg ut?",
  team: "Team",

  // Nettbasert Vurdering PositivtilbakemeldingSkjema (Positive feedback form)
  "please-go-to-previous-step-and-select-employee-without-employee-selection-not-able-to-submit-feedback-form":
    "Vennligst gå tilbake og velg ansatt. Uten valg av ansatt kan ikke tilbakemeldingsskjemaet sendes inn",
  "share-us-your-experience-with-us-today":
    "Del din opplevelse med oss i dag...",
  "did-employee-name-provide-exceptional-service":
    "Ga {employeeName} eksepsjonell service?",
  "did-employee-name-stand-out-for-delivering-exceptional-service":
    "Utmerket {employeeName} seg ved å levere eksepsjonell service?",

  // Nettbasert Vurdering Ny apiHjelpere innloggingsHjelpere (New api helper login helper)
  "please-enter-user-name": "Vennligst skriv inn brukernavn",
  "please-enter-password": "Vennligst skriv inn passord",

  // Nettbasert Vurdering Ny VurderingsLokasjoner (New ratings locations)
  search: "Søk",
  "select-loction-to-ratings": "Velg lokasjon for vurderinger",
  location: "Lokasjon",
  "is-this-your-location": "Er dette din lokasjon?",
  "fetch-details-failed": "Henting av detaljer mislyktes",

  // Nettbasert Vurdering Ny PositivReise AnsattDetaljer (New positive ratings employee details)
  "click-as-many-as-you-want": "Klikk så mange du vil",
  "what-made-employee-name-stand-out-to-you":
    "Hva gjorde at {employeeName} skilte seg ut?",
  "what-made-the-team-stand-out-to-you": "Hva gjorde at teamet skilte seg ut?",

  // Nettbasert Vurdering Ny PositivReise AnsattService (New positive ratings employee service)
  "did-we-stand-out-for-delivering-exceptional-service":
    "Skilte vi oss ut ved å levere eksepsjonell service?",

  // Nettbasert Vurdering Ny NegativReise AnsattPersonligDetaljer (New negative ratings employee personal details)
  "leave-an-email-or-phone-number-if-you-want-us-to-get-in-touch-otherwise-just-leave-it-blank-then-press-next":
    "Legg igjen en e-post eller telefonnummer hvis du ønsker at vi skal ta kontakt, ellers kan du la det stå tomt og trykke neste",
  "anything-else-you-d-like-to-share": "Er det noe annet du vil dele?",
  "enter-valid-email": "Skriv inn gyldig e-post",
  message: "Melding",
  "by-signing-up-the-form-you-agree-to-our-terms-and-privacy":
    "Ved å sende inn skjemaet godtar du våre vilkår og personvern.",

  // Nettbasert Vurdering Ny FrontNettInnlogging (New front login)
  login: "Logg inn",
  username: "Brukernavn",

  // Nettbasert Vurdering Ny FrontVurdering (New front rating)
  "press-the-facial-expression-that-best-represents-how-you-feel-about-your-experience":
    "Trykk på ansiktsuttrykket som best representerer hvordan du opplevde besøket.",
  "getting-employee-list": "Henter ansattliste",
  "getting-skill-data": "Henter ferdighetdata",
  "getting-screen-saver": "Henter skjermsparer",

  // Nettbasert Vurdering Ny FellesKomponenter TakkModal (Thank you modal)
  "thank-you-for-contacting-us": "Takk for at du kontaktet oss.",
  "we-ll-be-in-touch-very-soon": "Vi tar kontakt snart.",

  // Nettbasert Vurdering Ny FellesKomponenter GoogleQrSide (Google QR page)
  "you-can-follow-this-button-to-rate-us-on-google":
    "Du kan følge denne knappen for å vurdere oss på Google",
  "rate-us-on-google": "Vurder oss på Google",

  // Nettbasert Vurdering Ny FellesKomponenter KontaktOssModal (Contact us modal)
  "contact-us": "Kontakt oss",
  "or-you-may-reach-us-on": "...eller du kan nå oss på.",
  "do-you-want-to-learn-more-about-serve-first":
    "Vil du lære mer om Serve First?",

  // Nettbasert Vurdering Ny FellesKomponenter BunnLinje (Bottom bar)
  saving: "Lagrer",
  "please-enter-only-digits-for": "Vennligst skriv kun tall for",
  "please-enter": "Vennligst skriv inn",
  "enter-value-here": "Skriv verdi her",

  // Undersøkelse Sider Spørsmål Nedtrekksmeny (Questions dropdown)
  "please-select": "Vennligst velg",
  "survey-retry-message":
    "Du kan gjennomføre denne undersøkelsen etter {value} {unit}.",
  minute: "minutt",
  minutes: "minutter",
  hour: "time",
  hours: "timer",
  day: "dag",
  days: "dager",
  week: "uke",
  weeks: "uker",
  month: "måned",
  months: "måneder",
  clear: "Tørr",

  "powered-by": "Drevet av",
  "image-is-required": "Bilde er påkrevd",
  "please-fill-all-required-contact-information":
    "Vennligst fyll ut alle påkrevde kontaktinformasjoner",

  "please-leave-any-extra-feedback-in-the-box-below":
    "Vennligst la til ekstra tilbakemelding i boksen nedenfor.",
  "all-feedback-is-confidential": "Alle tilbakemeldinger er konfidensielle",
  "your-feedback-has-been-received-thank-you":
    "Din tilbakemelding er mottatt, takk",
  "close-page": "Lukk side",
  send: "Send",
  sending: "Sender",
  "enter-your-feedback-here": "Skriv din tilbakemelding her",
  "for-anything-else-please":
    "For øvrig, hvis det er et spesifikt tema du ønsker at teamet vårt skal ta opp, ikke nøl med å dele det. Jeg er her ikke bare for å lytte, men for å engasjere meg og handle på dine bekymringer eller ideer.",
  "please-correct-the-custom-field-values":
    "Vennligst korrigere verdiene for de personlige feltene",
  "please-complete-all-required-contact-information":
    "Vennligst fyll ut alle påkrevde kontaktinformasjoner",
  "survey-cannot-be-submitted": "Undersøkelsen kan ikke sendes inn",
  "please-enter-your-phone": "Vennligst skriv inn ditt telefonnummer",
  "network-error-please-try-again":
    "Nettverksfeil. Vennligst sjekk tilkoblingen og prøv igjen.",
  "no-results-found": "Ingen resultater funnet",
  "drop-files-here": "Slipp filene her...",
  "drag-drop-files": "Dra og slipp filer her, eller klikk for å velge filer",
  "max-5-files-5mb": "Maks 5 filer, 5 MB hver, kun bilder",
  remove: "Fjern",

  // Learning & Development

  "ld-module-title": "Læring og utvikling",
  "ld-no-sign-in-required": "Innlogging ikke påkrevd",
  "ld-progress-warning":
    "Ikke lukk dette vinduet — fremdriften din lagres ikke, og du må starte på nytt.",
  "ld-loading-module": "Laster læringsmodul…",
  "ld-unable-load-module": "Kan ikke laste læringsmodul.",
  "ld-package-not-configured": "Læringspakken er ikke konfigurert.",
  "ld-start-guidance": "Start opplæring",
  "ld-due-date": "Frist {date}",
  "ld-whats-involved": "Hva inngår",
  "ld-your-progress": "DIN FREMDRIFT",
  "ld-step-of": "Trinn {current} av {total}",
  "ld-watched-in-full": "Sett i sin helhet",
  "ld-video-no-skip": "Du kan spole tilbake, men ikke hoppe fremover",
  "ld-video-muted-counts": "Dempet — avspilling teller fortsatt",
  "ld-maximize-document": "Maksimer dokumentet",
  "ld-minimize-document": "Minimer dokumentet",
  "ld-read-percent": "{percent} % lest",
  "ld-end-of-document": "Slutt på dokumentet",
  "ld-scroll-to-continue": "Bla for å fortsette",
  "ld-read-to-end": "Lest til slutten",
  "ld-read-to-end-to-continue": "Les til slutten for å fortsette",
  "ld-loading-document": "Laster dokument…",
  "ld-pdf-preview-unavailable":
    "Kan ikke forhåndsvise denne PDF-en i nettleseren.",
  "ld-pdf-page-alt": "{title} — side {page}",
  "ld-knowledge-check": "KUNNSKAPSTEST",
  "ld-knowledge-check-title": "{title} — kunnskapstest",
  "ld-quiz-instruction":
    "Svar på {count, plural, one {# spørsmål} other {# spørsmål}}. Beståttgrense {passMark} %.",
  "ld-quiz-instruction-pass-only": "Beståttgrense {passMark} %.",
  "ld-question-of": "SPØRSMÅL {current} AV {total}",
  "ld-guidance-of": "OPPLÆRING {current} AV {total}",
  "ld-loading-questionnaire": "Laster spørreskjema…",
  "ld-preparing-questions": "Forbereder spørsmålene dine",
  "ld-submit-answers": "Send inn svar",
  "ld-submitting": "Sender inn…",
  "ld-ready-to-submit": "Klar til å sende inn svarene dine",
  "ld-answer-selected": "Svar valgt",
  "ld-select-answer": "Velg ett svar for å fortsette",
  "ld-pass-mark-note":
    "Du trenger {passMark} % eller høyere for å bestå. Svar kan ikke endres etter innsending.",
  "ld-questionnaire-not-configured": "Spørreskjemaet er ikke konfigurert.",
  "ld-unable-load-questionnaire": "Kan ikke laste spørreskjema.",
  "ld-no-visible-questions":
    "Ingen spørsmål er tilgjengelige for denne kunnskapssjekken akkurat nå.",
  "ld-unable-submit-answers": "Kan ikke sende inn svar. Prøv igjen.",
  "ld-not-passed": "Ikke bestått",
  "ld-completed": "Fullført",
  "ld-fail-title": "Nesten i mål — prøv igjen",
  "ld-fail-description":
    "Du fikk {score} — beståttgrensen er {passMark} %. Du har {remaining} igjen.",
  "ld-attempts-remaining": "{count, plural, one {# forsøk} other {# forsøk}}",
  "ld-attempt-of": "Forsøk {current} av {total}",
  "ld-fail-alert":
    "Ta deg tid til å gå gjennom veiledningen igjen, og ta testen på nytt. Etter siste forsøk låses testen.",
  "ld-try-again": "Prøv igjen",
  "ld-review-guidance": "Gå gjennom veiledning",
  "ld-locked-title": "Denne opplæringen er nå låst",
  "ld-locked-description":
    "Du fikk {score} — beståttgrensen for denne pakken er {passMark} %. Av hensyn til etterlevelse kan du ikke ta den på nytt her.",
  "ld-speak-to-manager": "Snakk med lederen din",
  "ld-locked-manager-copy":
    "Din vaktleder kan tildele {courseTitle} på nytt, slik at du kan gå gjennom veiledningen igjen og ta testen på nytt.",
  "ld-close-window": "Du kan nå lukke dette vinduet.",
  "ld-close-window-safe": "Du kan nå trygt lukke dette vinduet.",
  "ld-success-title": "Gratulerer!",
  "ld-success-description":
    "Du har fullført {courseTitle}. Dette er registrert i opplæringsprofilen din — du trenger ikke gjøre mer.",
  "ld-email-yourself": "Send en kopi til deg selv",
  "ld-email-copy-description":
    "Send en bekreftelse på fullføring til innboksen din for arkivering.",
  "ld-email-placeholder": "deg@bedrift.no",
  "ld-sent": "Sendt",
  "ld-sending-email": "Sender…",
  "ld-unable-send-email": "Kan ikke sende e-post. Prøv igjen.",
  "ld-email-sent-success": "Bekreftelses-e-post sendt!",
  "ld-video-briefing": "Videobriefing",
  "ld-document": "Dokument",
  "ld-video-meta": "Video",
  "ld-video-meta-no-skip": "Video · ingen hopping",
  "ld-document-meta": "Dokument · PDF",
  "ld-document-meta-scroll": "Dokument · PDF · bla til slutten",
  "ld-video-instruction-full": "Se hele videoen — du kan ikke hoppe fremover",
  "ld-video-instruction": "Se briefingen, og fortsett deretter",
  "ld-document-instruction-scroll": "Bla til slutten for å fortsette",
  "ld-document-instruction": "Gå gjennom dokumentet, og fortsett deretter",
  "ld-questionnaire": "Spørreskjema",
  "ld-confirmation": "Bekreftelse",
  "ld-question-count": "{count, plural, one {# spørsmål} other {# spørsmål}}",
  "ld-knowledge-check-subtitle": "Kunnskapstest",
  "ld-score": "Poengsum",
  "ld-whats-involved-pass-mark":
    "Beståttgrense {passMark} % · låses opp etter veiledning",
  "ld-document-type-pdf": "{documentType} · PDF",
};
